<template>
    <button class="btn btn-default btn--front-blue btn-super-wide" :disabled="isDisabled" @click.prevent.stop="postFillSection"><span class="glyphicon glyphicon-download" aria-hidden="true"></span> {{ label }}</button>

</template>

<script>
import { transmitter } from '../vuex/Transmitter';
import { mapState } from 'vuex';

export default {
    name: 'postfill-section',

    props: {
        sectionNumber: Number,
        answerSurveyId: Number,
        label: String,
    },

    data()
    {
        return {
            clicked: false,
        };
    },

    computed: {
        isDisabled()
        {
            if (this.clicked)
            {
                return true;
            }
            return this.blockButton;
        },
        ...mapState({
            blockButton(state)
            {
                return state.postFillButtonHidden
            },
        }),
    },

    methods: {

        postFillSection($event)
        {
            this.clicked = true;
            transmitter.postFillSection(this.sectionNumber, this.answerSurveyId, (response) =>
            {
                // console.debug(response.data);
                window.location.reload();
            });
        },

    },
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/vue/postfill-section.vue